const COLOR = {
  main: '#22CAE1', // 25D3EB  03a9f5
};

const BASIC = {
  spacing: 5, // 基本間距
  breakpoints: {
    values: {
      xs: 360,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1700, // 1920 1400
    },
  },
  maxWidth: 1400,
  mixins: {
    toolbar: {
      minHeight: 50,
    },
  },
  borderRadius: {
    large: 12,
    small: 8,
  },
  menu: {
    height: {
      primary: 50,
      secondary: 50,
    },
    fontSize: {
      primary: 16,
      secondary: 14,
    },
  },
  drawer: {
    padding: 5,
    width: 250,
  },
  typography: {
    fontFamily: `'Microsoft JhengHei','Roboto','Helvetica','Arial',sans-serif`,
  },
  cis: {
    blue: '#008FCD',
    yellow: '#F6CA00',
    green: '#9BBE1E',
    gray: '#595757',
  },
};

const isB2B = localStorage.m_class === 'm_b2b' && localStorage.m_mid;

const THEME_LIGHT = {
  ...BASIC,
  palette: {
    primary: {
      // 主色系
      main: isB2B ? '#fe8032' : COLOR.main,
      text: '#FFFFFF', // 使用主色系時搭配的文字顏色
      hover: isB2B ? 'rgba(245, 82, 0, 1)' : '#1ca5b7', // 主色系hover顏色
      contrastText: '#FFFFFF', // 使用主色系時搭配的文字顏色

      // 新加入
      brandBlue: '#008FCD',
      brandGreen: '#9BBE1E',
      brandColor: '#0BC6E0',
    },
    text: {
      // 文字顏色
      main: '#222', // 一般文字
      secondary: '#666', // 次要文字
      third: '#CCC', // 第3文字
      title: '#000', // 大項目標題
      label: '#999', // 小項目標題
      note: '#999', // 註解
      red: '#F7595A', // 紅
      green: '#9BBE1E', // 綠
      blue: '#256fc7', // 藍
      disable: '#CCCCCC', // 禁用
      error: '#D32F2F', // 錯誤
      orange: '#FAA701', // 橘

      // 新加入
      primary: '#222222',
      brand: '#0191A6',
      oldTextField: '#808080',
      error700: '#B52B30',
      muiDisabled: '#00000061',
    },
    background: {
      // 背景顏色
      default: '#F8F8F8', // body
      paper: '#FFFFFF', // 區塊底
      hover: '#F5F5F5', // hover
      paperOpacity: 'rgba(255,255,255,.7)', // 區塊底 半透明
      paperTitleOpacity: 'rgba(255,255,255,.6)', // 區塊標題底 半透明
      searchRecord: '#F5F5F5', // 搜尋記錄項目
      searchRecordHover: '#DEDEDE', // 搜尋記錄項目 hover
      blackOpacity:
        'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,.3) 60%, rgba(0,0,0,.4) 100%)', // 圖片文字背景 半透明黑
      blackOpacity2: 'rgba(0,0,0,.65)', // 半透明黑
      dark: '#EEEEEE', // 深色底
      calendar: {
        // 日曆
        today: isB2B ? '#FA8900' : COLOR.main, // 今天
      },
      table: {
        // 表格
        odd: '#FAFAFA',
      },
      discount: '#FA8900', // 優惠
      box: {
        travelInfo: '#cff0f5',
        default: '#F8F8F8',
      },
      yellow: '#F6CA00',
      containerHover: '#F0F0F0',
      b2bMain: '#FF6600',

      // 新加入
      radiusBtnHover: '#E0E0E0',
      chipHover: '#E0F9FC',
      containerError: '#FFF2F2',
      containerErrorHover: '#FFE5E5',
      market: '#D3F5FB',
    },
    line: {
      // 線條顏色
      main: '#EFEFEF', // 主 淺灰
      secondary: '#DEDEDE', // 次 深灰
      hide: '#FFFFFF', // 要有線條但不顯示時使用
      input: '#CCC', // input btn 邊框
      disable: '#F5F5F5', // input btn 邊框禁用時
      red: '#F7595A', // 紅
      LINE: '#06c755', // LINE 綠
      gray: '#888', // 黑
      calendar: {
        // 日曆
        main: '#EEEEEE',
      },
      mainLine: '#25D3EB',

      // 新加入
      light: '#E2E2E2',
      dark: '#B3B3B3',
      radiusBtn: '#C4C4C4',
      question: '#D9D9D9',
    },
    icon: {
      // 圖示
      main: '#999', // 主
      hover: '#666', // hover

      // 新加入
      iconMain: '#74858B',
      secondary: '#929FA4',
      disabled: '#B3BABC',
      iconHover: '#566368',
      radiusBtn: '#6F7978',
      iconBtnHover: '#DCDCDC',
      chipIconBtnHover: '#B3EFF6',
    },
    // 新加入
    error: {
      main: '#F7595A',
    },
    alert: {
      error: '#F7595A', // 紅
      warning: '#FAA701', // 橘
      info: '#00D5EF', // 藍
      success: '#60AC2B', // 綠
    },
    button: {
      // 按鈕
      shadow: {
        // 陰影
        main: 'rgb(42, 218, 186, .4) 0 5px 10px', // 主色系
        red: 'rgb(247, 89, 90, .4) 0 5px 10px', // 紅
        green: 'rgb(158, 189, 50, .4) 0 5px 10px', // 綠
      },
      // 新加入
      regular: '#25D3EB',
      hover: '#0FB5CC',
      oldButton: '#3F4948',
    },
    shadow: {
      // 陰影
      main: '0px 8px 20px 0px rgba(0, 0, 0, 0.10)', // 主選單區塊陰影
      hover: '0px 4px 8px 0px rgba(0, 0, 0, 0.05)', // hover

      // 新加入
      navi: '0px 4px 16px rgba(0, 0, 0, 0.1)',
      navi_s: '0px -4px 16px rgba(0, 0, 0, 0.08)',
      CTA_navi: '0px 4px 16px rgba(0, 0, 0, 0.1)',
      blue_shadow: '0px 2px 10px rgba(37, 211, 235, 0.25)',
      select_shadow: '0px 2px 8px rgba(183, 183, 183, 0.3)',
      chip_shadow: '0px 1px 2px rgba(0, 0, 0, 0.08)',
      chip_shadow_hover: '0px 4px 6px rgba(0, 0, 0, 0.12)',
      home_shadow: '0px 2px 10px rgba(185, 187, 188, 0.25)',
      search_lv1: '0px 6px 10px 4px rgba(0, 0, 0, 0.12)',
      search_lv2: '0px 11px 15px -7px rgba(0, 0, 0, 0.2)',
      scrollBtn: '0px 2px 10px 0px rgba(177, 177, 177, 0.25)',
      scrollBtn_hover: '0px 4px 20px 0px rgba(0, 0, 0, 0.16)',
    },
    // 新加入
    linearGradient: {
      // 漸層
      greenBlueGradient:
        'linear-gradient(226.1deg, #25D3EB 11.32%, #9BBE1E 90.14%)',
    },
  },
  button: {
    // 按鈕
    shadow: {
      // 陰影
      main: isB2B
        ? 'rgba(245, 82, 0, 0.4) 0 5px 10px'
        : 'rgb(42, 218, 186, .4) 0 5px 10px', // 主色系
      red: 'rgb(247, 89, 90, .4) 0 5px 10px', // 紅
      green: 'rgb(158, 189, 50, .4) 0 5px 10px', // 綠
    },
    backgroundImage: isB2B
      ? ''
      : 'linear-gradient(to right, #25D3EB 20%, #21BBF5  50%, #25D3EB  100%)',
  },
  shadow: {
    // 陰影
    main: '0px 8px 20px 0px rgba(0, 0, 0, 0.10)', // 主選單區塊陰影
    hover: '0px 4px 8px 0px rgba(0, 0, 0, 0.05)', // hover
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: '#FFF',
          backgroundColor: 'rgba(0,0,0,.8)',
          fontSize: '12px',
          padding: '4px 8px',
          borderRadius: '5px',
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true, // 禁用 ripple 按鈕涟漪效果
      },
    },
  },
};

const THEME_DARK = {
  ...BASIC,
  palette: {
    mode: 'dark',
    background: {
      default: '#111',
    },
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
};

export { THEME_LIGHT, THEME_DARK };
